module.exports = __webpack_public_path__ + "static/media/24.e506cc57.jpg";